import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

// local component imports
import CollectionWidget from "./CollectionWidget";

// dynmically imported components
const ProductCollectionWidget = dynamic(() => import("./ProductCollectionWidget"), { ssr: true });
const ProductWithTabWidget = dynamic(() => import("./ProductWithTabWidget"), { ssr: true });
const VideoWidget = dynamic(() => import("./VideoWidget"), { ssr: false });

// services and utils imports
import { WIDGET_TYPE } from "../../../../constants/pageConstants/dynamicHomeConstants";

/**
 * Registry routes a widget to the appropriate widget component based on its type.
 * @param {object} props - Component props
 * @param {number} props.order - Widget render order index
 * @param {object} props.widget - Widget configuration object
 * @param {boolean} props.isAboveFold - Whether this widget is expected above the fold
 * @param {boolean} props.isLcpCandidate - Whether this widget may contain the LCP image
 * @returns {React.ReactElement|null} The matched widget component or null
 */
const Registry = ({ order, widget, isMobile, isAboveFold = false, isLcpCandidate = false }) => {
  if (!widget?.widgetType) return null;
  switch (widget.widgetType) {
    case WIDGET_TYPE.COLLECTIONS:
      return (
        <CollectionWidget
          widget={widget}
          isMobile={isMobile}
          isAboveFold={isAboveFold}
          isLcpCandidate={isLcpCandidate}
        />
      );
    case WIDGET_TYPE.PRODUCT_COLLECTION:
      return (
        <ProductCollectionWidget
          widget={widget}
          isMobile={isMobile}
          isAboveFold={isAboveFold}
          isLcpCandidate={isLcpCandidate}
        />
      );
    case WIDGET_TYPE.PRODUCTS_WITH_TABS:
      return <ProductWithTabWidget widget={widget} isMobile={isMobile} />;
    case WIDGET_TYPE.VIDEO:
      return <VideoWidget order={order} widget={widget} isMobile={isMobile} />;
    default:
      return null;
  }
};

Registry.propTypes = {
  order: PropTypes.number.isRequired,
  widget: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
  isAboveFold: PropTypes.bool,
  isLcpCandidate: PropTypes.bool,
};

export default Registry;
